module.exports = __webpack_public_path__ + "media/poema.51062dc0.mp3";